// removed by extract-text-webpack-plugin
module.exports = {"AudioGuidesList":"WW7ObkV6NRKqETNgOr5He","help":"_3KMxctXrGCY--XskUUPdIf","helpIcon":"oG4ZSNMLQuTKBVleBfN_4","itemsContainer":"kafPtfhYucEHilqD5f86Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AudioGuideComponents/AudioGuidesList/AudioGuidesList.css
// module id = 473
// module chunks = 8